{
  "version": 1,
  "asset_id": "7eb750cf-2c64-42b3-a04e-7b76004caf26",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/7eb750cf-2c64-42b3-a04e-7b76004caf26/metal-roof-installation-citrus-county-fl-640.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/7eb750cf-2c64-42b3-a04e-7b76004caf26/metal-roof-installation-citrus-county-fl-640.webp",
  "original_filename": "metal-roof-installation-citrus-county-fl-640.webp",
  "size": 49912,
  "content_type": "image/webp",
  "created_at": "2026-07-16T15:36:35Z"
}
